import { render, staticRenderFns } from "./DetaildedWaybillExport.vue?vue&type=template&id=896e4fa0&"
import script from "./DetaildedWaybillExport.vue?vue&type=script&lang=js&"
export * from "./DetaildedWaybillExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports